<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Annotator Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.createdDate"
                label="Created Date"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|min:3'"
                data-vv-name="first name"
                :error-messages="errors.collect('first name')"
                v-model="item.firstName"
                label="First Name">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|min:2'"
                data-vv-name="last name"
                :error-messages="errors.collect('last name')"
                v-model="item.lastName"
                label="Last Name">
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                v-validate="'required|email'"
                data-vv-name="email"
                :error-messages="errors.collect('email')"
                v-model="item.email"
                label="E-Mail">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                v-validate="'numeric'"
                data-vv-name="phone number"
                :error-messages="errors.collect('phone number')"
                v-model="item.phoneNumber"
                mask="phone"
                label="Phone Number">
                </v-text-field>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapActions } from 'vuex'
import Vue from 'vue'

export default {
  name: 'annotator-item',
  props: {
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    if (!this.isNew) {
      this.setLoader({
        loading: true
      })
      this.fetchAnnotator()
    }
  },
  data () {
    return {
      item: {
        id: '',
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        isActive: true
      },
      saveLoading: false
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    }
  },
  methods: {
    cancel () {
      this.$router.go(-1)
    },
    fetchAnnotator () {
      this.axios.get(`/annotators/${this.id}`)
        .then(response => {
          this.setAnnotatorItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setAnnotatorItem (item) {
      item = this.mapAnnotatorItem(item)
      this.item = item
      this.item.id = this.id
      this.item.createdDate = item.createdDate
    },
    mapAnnotatorItem (user) {
      return {
        firstName: user.first_name,
        lastName: user.last_name,
        email: user.email,
        phoneNumber: user.phone_number,
        isActive: user.is_active,
        createdDate: Vue.options.filters.formatDate(user.created_date)
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        first_name: this.item.firstName,
        last_name: this.item.lastName,
        is_active: this.item.isActive,
        email: this.item.email,
        phone_number: this.item.phoneNumber
      }

      if (this.isNew) {
        itemToSave.is_active = false
        this.axios.post('/annotators', itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        this.axios.put(`/annotators/${this.item.id}`, itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.$router.go(-1)
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
